import { BasicTabState } from "./basic-tab-state";
import { prop } from "../../../decorators/property";

export class ListTabState extends BasicTabState {
    @prop() public ShowAllRelations = false;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/list-tab-state.ts